<template>
  <section class="block-contacts contacts">
    <observer @display="waitYmaps"></observer>
    <div class="container">
      <div class="contacts__content">
        <div class="contacts__dealer-name"><span>Ауди</span> Центр Север</div>
        <div class="contacts__slogan">Ориентируйся по звездам на север</div>

        <img
          class="contacts__best-logo"
          src="../images/icons/best.png"
          alt="Лучший отдел продаж"
        />

        <div class="contacts__wrapper">
          <p class="contacts__title">Адрес</p>
          <p class="contacts__info">{{ CONSTANTS.offices[0].address }}</p>
        </div>

        <div class="contacts__wrapper">
          <p class="contacts__title">Телефон</p>
          <v-phone :raw="CONSTANTS.phone_raw" class="contacts__info">
            {{ CONSTANTS.phone }}
          </v-phone>
        </div>

        <div class="contacts__wrapper">
          <p class="contacts__title">Режим работы</p>
          <p class="contacts__info">Ежедневно {{ CONSTANTS.worktime }}</p>
        </div>

        <button
          class="contacts__btn button button_theme_black"
          @click="
            getCall({ type: 'sale', form: 'header', title: 'Заказать звонок' })
          "
        >
          <span>Заказать звонок</span>
        </button>
      </div>
    </div>

    <div class="contacts__map" id="ya-karto"></div>
  </section>
</template>

<script>
import Mask from "../common/mask";
import Mixin from "../common/mixin";
import Keyup from "../common/keyup";
import CallbackInput from "./callback-form/callback-input";
import Observer from "./observer.vue";
import VPhone from "./v-phone.vue"
import placemarkImg from "../images/utils/map.svg";

export default {
  name: "block-contacts",
  components: { CallbackInput, Observer, VPhone },
  directives: { Mask, Keyup },
  mixins: [Mixin],
  data() {
    return {
      phone: "",
    };
  },
  mounted() {
    // this.$nextTick(this.waitYmaps);
  },
  methods: {
    initYandexMap() {
      const isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        },
      };

      let zoomControl = new ymaps.control.ZoomControl({
        options: {
          position: {
            left: "auto",
            right: 9,
            top: 108,
          },
        },
      });

      let center_x = this.CONSTANTS.coords.x_center;
      let center_y = this.CONSTANTS.coords.y_center;

      let myMap = new ymaps.Map(
        "ya-karto",
        {
          center: [center_y, center_x],
          zoom: 15,
          controls: [],
        },
        {
          searchControlProvider: "yandex#search",
        }
      );
      if (!isMobile.any()) {
        myMap.controls.add(zoomControl);
      }

      this.CONSTANTS.offices.forEach((point, i) => {
        myMap.geoObjects.add(
          new ymaps.Placemark(
            [point.y, point.x],
            {
              iconContent: point.address,
            },
            {
              iconLayout: "default#image",
              iconImageHref: placemarkImg,
              iconImageSize: [50, 60],
              iconImageOffset: [-10, 30],
              iconContentOffset: [45, 3],
            }
          )
        );
      });

      if (isMobile.any() || this.device_platform !== "desktop") {
        myMap.behaviors.disable("drag");
      }
      myMap.behaviors.disable("scrollZoom");
    },
    waitYmaps() {
      let script = document.createElement("script");
      script.src = "//api-maps.yandex.ru/2.1/?load=package.standard&lang=ru_RU";
      document.head.appendChild(script);
      script.onload = () => {
        ymaps.ready(this.initYandexMap);
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.contacts {
  position: relative;

  .container {
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 50;
    padding-top: 50px;
    pointer-events: none;
  }

  &__content {
    width: 400px;
    max-width: 100%;
    padding: 35px 30px;
    background-color: #fff;
    z-index: 100;
    pointer-events: all;
    margin-left: auto;
  }

  &__best-logo {
    width: 250px;
    margin-bottom: 10px;
  }

  &__dealer-name {
    font-family: "AudiTypeExt", sans-serif;
    font-size: 24px;
    font-weight: bold;

    span {
      color: $red;
    }
  }
  &__slogan {
    margin-bottom: 20px;
  }

  &__wrapper {
    margin-bottom: 20px;
  }

  &__title {
    font-size: 13px;
    color: #828282;
    margin-bottom: 5px;
  }

  &__info {
    font-size: 16px;
    font-weight: bold;
  }

  &__btn {
    width: 100%;
  }

  &__map {
    width: 100%;
    height: 500px;
  }
}

@media (max-width: 640px) {
  .contacts {
    display: flex;
    flex-direction: column;

    .container {
      position: unset;
      padding: 0;
      transform: translateX(0);
    }

    &__content {
      width: 100%;
      padding: 36px 10px 34px 17px;
    }

    &__map {
      height: 300px;
    }
  }
}
</style>
